import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import user from './modules/user'
import notice from './modules/notice'
import yamatodeliveryinfo from './modules/yamatodeliveryinfo'
import shippingmultichannelinfo from './modules/shippingmultichannelinfo'
import scshippingmultichannelinfo from './modules/scshippingmultichannelinfo'
import products from './modules/products'
import video from './modules/video'
import app from './modules/app'
import pagination from './modules/pagination'
Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'salmon',
  storage: window.localStorage,
  filter: (mutation) => mutation.type !== 'saveResultCode'
})

const store = new Vuex.Store({
  modules: {
    app,
    user,
    notice,
    yamatodeliveryinfo,
    shippingmultichannelinfo,
    scshippingmultichannelinfo,
    products,
    video,
    pagination
  },
  strict: false,
  plugins: [vuexLocalStorage.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js